<template>
  <div class="content card-inventory-page">
    <!-- 出入库汇总：一眼看清本期库存进出 -->
    <div class="summary-block">
      <div class="summary-item summary-item--in">
        <div class="summary-label">入库总量</div>
        <div class="summary-value">{{ formatNumber(summary.inTotal) }}</div>
        <div class="summary-unit">张</div>
      </div>
      <div class="summary-item summary-item--out">
        <div class="summary-label">出库总量</div>
        <div class="summary-value">{{ formatNumber(summary.outTotal) }}</div>
        <div class="summary-unit">张</div>
      </div>
      <div class="summary-item summary-item--net">
        <div class="summary-label">净入库量</div>
        <div class="summary-value">{{ formatNumber(summary.netTotal) }}</div>
        <div class="summary-unit">张</div>
      </div>
    </div>

    <!-- 查询区 -->
    <div class="query-block">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="0">
        <el-form-item prop="inventoryTimeRange">
          <el-date-picker
            v-model="queryParams.inventoryTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="入库时间起"
            end-placeholder="入库时间止"
            value-format="yyyy-MM-dd"
            class="wd-340">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="operationNames">
          <el-select v-model="queryParams.operationNames" placeholder="运营商" multiple filterable clearable class="wd-200">
            <el-option v-for="item in operatorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="channelIds">
          <el-select v-model="queryParams.channelIds" placeholder="卡源" multiple clearable filterable class="wd-200">
            <el-option v-for="item in sourceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="queryParams.status" placeholder="出入库状态" clearable class="wd-200">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="iccidStart">
          <el-input v-model="queryParams.iccidStart" placeholder="ICCID开始号段" clearable class="wd-200"></el-input>
        </el-form-item>
        <el-form-item prop="iccidEnd">
          <el-input v-model="queryParams.iccidEnd" placeholder="ICCID结束号段" clearable class="wd-200"></el-input>
        </el-form-item>
        <el-form-item prop="orderNum">
          <el-input v-model="queryParams.orderNum" placeholder="订单号" clearable class="wd-200"></el-input>
        </el-form-item>
        <el-form-item  prop="physicalTypeName" >
          <el-select v-model="queryParams.physicalTypeName" multiple placeholder="请选择物理卡类型" filterable clearable class="wd-200">
            <el-option
              v-for="dict in dict.type.card_physical_name"
              :key="dict.value"
              :label="dict.label"
              :value="dict.label"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item  prop="cardTypeSortName">
          <el-select v-model="queryParams.cardTypeSortName" multiple placeholder="请选择卡品类型"  clearable class="wd-200">
            <el-option
              v-for="dict in dict.type.card_type_sort_name"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardTypeName">
          <el-select v-model="queryParams.cardTypeName" multiple placeholder="请选择卡类型" filterable clearable class="wd-200">
            <el-option
              v-for="dict in dict.type.card_type_name"
              :key="dict.value"
              :label="dict.label"
              :value="dict.label"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item  prop="orientations">
          <el-select v-model="queryParams.orientations" multiple placeholder="请选择卡定向类型" filterable  clearable class="wd-200">
            <el-option
              v-for="item in orientationList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          <el-button type="success" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      v-loading="loading"
      class="data-table"
      show-summary
      :summary-method="getPageSummary"
      :header-cell-style="{ background: '#f5f7fa', color: '#303133' }"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row>
              <el-col :span="6">
                <el-form-item label="物理卡类型：">
                  <span>{{ props.row.cardPhysicalName || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="卡品类型：">
                  <span>{{ props.row.cardTypeSortName || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="卡类型：">
                  <span>{{ props.row.cardTypeName || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="卡定向类型：">
                  <span>{{ props.row.cardOrientation || '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="订单号：">
                  <div class="cell-flex">
                    <span
                      class="cell-text"
                      :class="{ 'order-link': !isOutbound(props.row) }"
                      @click="!isOutbound(props.row) && openDeductDetail(props.row.orderNum)">
                      {{ props.row.orderNum || '--' }}
                    </span>
                    <el-tooltip v-if="props.row.orderNum" content="复制" placement="top">
                      <i class="el-icon-document-copy copy-icon" @click="copy(props.row.orderNum)"></i>
                    </el-tooltip>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="池场景：">
                  <span>{{ props.row.poolScene || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="创建时间：">
                  <span>{{ props.row.createTime || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="创建人：">
                  <span>{{ props.row.createUser || '--' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 扣减链路：出库看扣的哪批入库；入库看被哪些出库扣过 -->
            <el-row v-if="isOutbound(props.row)" style="margin-top: 6px;">
              <el-col :span="24">
                <el-form-item label="扣减入库单：">
                  <template v-if="sourceOrderList(props.row).length">
                    <span
                      v-for="order in sourceOrderList(props.row)"
                      :key="order"
                      class="source-link"
                      @click="openDeductDetail(order)">
                      {{ order }}
                    </span>
                  </template>
                  <span v-else>--</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else style="margin-top: 6px;">
              <el-col :span="24">
                <el-form-item label="扣减出库单：">
                  <span class="source-link" @click="openDeductDetail(props.row.orderNum)">
                    查看扣减明细
                    <i class="el-icon-right" style="margin-left: 4px;"></i>
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column type="index" label="序号" align="center" width="60" :index="indexMethod"></el-table-column>

      <el-table-column prop="inventoryTime" label="入库时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.inventoryTime || '--' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="运营商 / 卡源" align="center" width="170">
        <template slot-scope="scope">
          <div class="cell-stack">
            <el-tag :type="operatorTagType(scope.row.operationName)" size="mini" effect="plain">
              {{ scope.row.operationName || '--' }}
            </el-tag>
            <span class="cell-sub">{{ scope.row.channelName || '--' }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="ICCID号段" align="center" min-width="180">
        <template slot-scope="scope">
          <div class="cell-stack">
            <span class="cell-text">
              <span class="cell-label">开始：</span>{{ scope.row.iccidStart || '--' }}
            </span>
            <span class="cell-text">
              <span class="cell-label">结束：</span>{{ scope.row.iccidEnd || '--' }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="数量/PCS" align="center" width="160">
        <template slot-scope="scope">
          <div class="cell-stack">
            <span :class="totalClass(scope.row.total)">{{ formatTotal(scope.row.total) }}</span>
            <span v-if="String(scope.row.status) === '1'" class="cell-sub">
              剩余量：{{ scope.row.remaining ? scope.row.remaining : '0' }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="状态" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row)" size="mini">{{ statusText(scope.row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="220" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.remark || '--' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" align="center" width="80">
        <template slot-scope="scope" v-if="scope.row.operation == 'save'">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>

      <template slot="empty">
        <div class="empty-text">暂无库存记录</div>
      </template>
    </el-table>

    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 新增 / 修改库存记录 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="760px"
      append-to-body
      :close-on-click-modal="false"
      @closed="dialogClosed"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="96px" class="inventory-form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="入库时间" prop="inventoryTime">
              <el-date-picker
                v-model="form.inventoryTime"
                type="datetime"
                placeholder="请选择入库时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运营商" prop="operationName">
              <el-select v-model="form.operationName" placeholder="请选择运营商" style="width: 100%">
                <el-option v-for="item in operatorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="卡源" prop="channelId">
              <el-select v-model="form.channelId" placeholder="请选择卡源" filterable style="width: 100%">
                <el-option v-for="item in sourceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="起始号段" prop="iccidStart">
              <el-input v-model="form.iccidStart" placeholder="请输入起始号段" maxlength="32" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束号段" prop="iccidEnd">
              <el-input v-model="form.iccidEnd" placeholder="请输入结束号段" maxlength="32" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数量" prop="total">
              <el-input-number
                v-model="form.total"
                :step="1"
                step-strictly
                placeholder="入库为正 / 出库为负"
                style="width: 100%"
                @change="handleTotalChange">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物理卡类型" prop="cardPhysicalName">
              <el-select v-model="form.cardPhysicalName" placeholder="请选择物理卡类型" filterable clearable style="width: 100%">
                <el-option v-for="dict in dict.type.card_physical_name" :key="dict.value" :label="dict.label" :value="dict.label"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡片类型" prop="cardTypeSortName">
              <el-select v-model="form.cardTypeSortName" placeholder="请选择卡片类型" filterable clearable style="width: 100%">
                <el-option v-for="dict in dict.type.card_type_sort_name" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡类型" prop="cardTypeName">
              <el-select v-model="form.cardTypeName" placeholder="请选择卡类型" filterable clearable style="width: 100%">
                <el-option v-for="dict in dict.type.card_type_name" :key="dict.value" :label="dict.label" :value="dict.label"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡定向类型" prop="cardOrientation">
              <el-select v-model="form.cardOrientation" placeholder="请选择卡定向类型" filterable clearable style="width: 100%">
                <el-option v-for="item in orientationList" :key="item.name" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="池场景" prop="poolScene">
              <el-input v-model="form.poolScene" placeholder="请输入池场景" maxlength="32" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="200" show-word-limit placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 操作提示：保存可改 / 提交锁定 -->
        <div class="submit-tip">
          <i class="el-icon-info"></i>
          点击「保存」后记录仍可修改；点击「提交」后，此记录不可修改，请谨慎操作。
        </div>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">提 交</el-button>
        <el-button type="success" :loading="submitLoading" @click="saveForm">保 存</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 扣减明细弹窗：查看某入库单被哪些出库单扣减 -->
    <el-dialog :title="deductTitle" :visible.sync="deductOpen" width="860px" append-to-body>
      <div v-loading="deductLoading">
        <div class="deduct-summary">
          <span>入库单号：{{ (deductSource && deductSource.orderNum) || '--' }}</span>
          <template v-if="deductSource && deductSource.total !== undefined">
            <span>入库数量：{{ formatNumber(deductSource.total) }}</span>
            <span>剩余量：{{ formatNumber(deductSource.remaining) }}</span>
          </template>
        </div>
        <el-table :data="deductList" border size="mini" :header-cell-style="{ background: '#f5f7fa', color: '#303133' }">
          <el-table-column type="index" label="#" align="center" width="50"></el-table-column>
          <el-table-column prop="orderNum" label="出库单号" align="center" min-width="200"></el-table-column>
          <el-table-column prop="inventoryTime" label="出库时间" align="center" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.inventoryTime || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量/PCS" align="center" width="100">
            <template slot-scope="scope">
              <span class="deduct-total-out">{{ formatTotal(scope.row.total) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operationName" label="运营商" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.operationName || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" min-width="140" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.remark || '--' }}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="deduct-empty">该入库单暂无出库扣减记录</div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deductOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  cardInventoryList,
  cardInventorySummary,
  cardInventorySave,
  cardInventoryUpdate,
  cardInventoryInfo,
  cardSource,
  cardBaseInfo,
  cardInInventoryList
} from "@/api/api.js";

// 出入库状态：与后端 status 字段对齐，编码不同只改这里
const STATUS_OPTIONS = [
  { value: "1", label: "入库", tag: "success", sign: 1 },
  { value: "2", label: "出库", tag: "warning", sign: -1 }
];

const OPERATOR_OPTIONS = [
  { value: "中国移动", label: "中国移动", tag: "primary" },
  { value: "中国联通", label: "中国联通", tag: "warning" },
  { value: "中国电信", label: "中国电信", tag: "success" },
  { value: "国际", label: "国际", tag: "info" }
];

export default {
  name: "CardInventory",
  dicts: ["card_physical_name", "card_type_sort_name", "card_type_name"],
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      // 查询条件
      queryParams: {
        operationName: undefined,
        channelIds: [],
        status: undefined,
        iccidStart: undefined,
        iccidEnd: undefined,
        orderNum: undefined,
        inventoryTimeRange: []
      },
      orientationList:[],
      tableData: [],
      // 汇总：入库 / 出库 / 净入库
      summary: {
        inTotal: 0,
        outTotal: 0,
        netTotal: 0
      },
      sourceOptions: [],
      operatorOptions: OPERATOR_OPTIONS,
      statusOptions: STATUS_OPTIONS,
      // 新增 / 修改弹窗
      open: false,
      title: "",
      submitLoading: false,
      form: {},
      // 扣减明细弹窗：入库单被哪些出库单扣减
      deductOpen: false,
      deductLoading: false,
      deductSource: null,
      deductList: [],
      rules: {
        inventoryTime: [{ required: true, message: "请选择入库时间", trigger: "change" }],
        operationName: [{ required: true, message: "请选择运营商", trigger: "change" }],
        channelId: [{ required: true, message: "请选择卡源", trigger: "change" }],
        cardPhysicalName: [{ required: true, message: "请选择物理卡类型", trigger: "change" }],
        cardTypeSortName: [{ required: true, message: "请选择卡片类型", trigger: "change" }],
        cardTypeName: [{ required: true, message: "请选择卡类型", trigger: "change" }],
        total: [
          { required: true, message: "请输入数量", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === undefined || value === null || value === "") {
                callback(new Error("请输入数量"));
              } else if (Number(value) === 0) {
                callback(new Error("数量不能为 0"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    /** 扣减明细弹窗标题 */
    deductTitle() {
      return this.deductSource && this.deductSource.orderNum
        ? `扣减明细 - ${this.deductSource.orderNum}`
        : "扣减明细";
    },
    /** 本页合计：当前页入库/出库/剩余（剩余 = 入库合计 - 出库合计） */
    pageStat() {
      let inTotal = 0;
      let outTotal = 0;
      (this.tableData || []).forEach(row => {
        const num = Number(row.total);
        if (isNaN(num)) return;
        if (num > 0) {
          inTotal += num;
        } else {
          outTotal += Math.abs(num);
        }
      });
      return { inTotal, outTotal, remain: inTotal - outTotal };
    }
  },
  created() {
    this.cardRequirements();
    this.getSourceOptions();
    this.getList();
  },
  methods: {
    /** 序号：跨页连续 */
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1;
    },
    /** 查询条件组装：日期区间转 startTime / endTime（补全时分秒，保证结束当天全包含） */
    buildParams() {
      const model = this.addDateRange(
        { ...this.queryParams },
        this.queryParams.inventoryTimeRange
      );
      delete model.inventoryTimeRange;
      if (model.startTime) {
        model.startTime += ' 00:00:00';
      }
      if (model.endTime) {
        model.endTime += ' 23:59:59';
      }
      return model;
    },
    /** 获取列表 */
    getList() {
      this.loading = true;
      const params = {
        model: this.buildParams(),
        page: this.page,
        pageSize: this.pageSize
      };
      cardInventoryList(params)
        .then(res => {
          this.loading = false;
          if (res.data.code === 200) {
            const data = res.data.data || {};
            this.tableData = data.records || [];
            this.total = data.total || 0;
            // 汇总优先取列表返回值，没有再单独请求
            if (data.summary) {
              this.summary = { inTotal: 0, outTotal: 0, netTotal: 0, ...data.summary };
            } else {
              this.getSummary();
            }
          } else {
            this.$message.error(res.data.message || "获取库存记录失败");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /** 汇总统计 */
    getSummary() {
      cardInventorySummary({ model: this.buildParams() })
        .then(res => {
          if (res.data.code === 200 && res.data.data) {
            this.summary = { inTotal: 0, outTotal: 0, netTotal: 0, ...res.data.data };
          }
        })
        .catch(() => {});
    },
    /** 卡源下拉 */
    getSourceOptions() {
      cardSource({}).then(res => {
        this.sourceOptions = res.data.data || [];
      });
    },
    /** 查询 */
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    /** 重置 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.inventoryTimeRange = [];
      this.handleQuery();
    },
    /** 导出 */
    handleExport() {
      this.download(
        "/card/inventory/export",
        { ...this.buildParams() },
        `卡库存记录_${new Date().getTime()}.xlsx`
      );
    },
    /** 编辑：列表行已含全字段，直接回填，不再单独查详情 */
    handleEdit(row) {
      this.resetFormData();
      cardInventoryInfo({id: row.id}).then(res=>{
        this.form = res.data.data || {};
      })
      this.title = "编辑库存记录";
      this.open = true;
    },

    /* ---------- 新增 / 修改 ---------- */
    /** 表单默认值 */
    resetFormData() {
      this.form = {
        id: undefined,
        inventoryTime: undefined,
        operationNames: undefined,
        channelId: undefined,
        iccidStart: undefined,
        iccidEnd: undefined,
        total: undefined,
        cardPhysicalName: undefined,
        cardTypeSortName: undefined,
        cardTypeName: undefined,
        cardOrientation: undefined,
        poolScene: undefined,
        remark: undefined
      };
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    cardRequirements(){
      cardBaseInfo().then(res=>{
        this.orientationList = res.data.data.orientations;
        this.orientationList.sort((a, b) => b.name.localeCompare(a.name));
      })
    },
    /** 新增 */
    handleAdd() {
      this.resetFormData();
      this.title = "新增库存记录";
      this.open = true;
    },
    /** 修改：列表行已含全字段，直接回填，不再单独查详情 */
    handleUpdate(row) {
      this.resetFormData();
      cardInventoryInfo({id: row.id}).then(res=>{
        this.form = res.data.data || {};
      })
      this.title = "修改库存记录";
      this.open = true;
    },
    /** 改数量：同步出入库状态 */
    handleTotalChange(val) {
      const num = Number(val);
      if (isNaN(num) || num === 0) return;
      this.form.status = num > 0 ? "1" : "2";
    },
    /** 提交 */
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        // 只提交实体字段，避免把列表里的派生字段（channelName、createTime 等）带上去
        const payload = {
          id: this.form.id,
          inventoryTime: this.form.inventoryTime,
          operationName: this.form.operationName,
          channelId: this.form.channelId,
          iccidStart: this.form.iccidStart,
          iccidEnd: this.form.iccidEnd,
          total: this.form.total,
          cardPhysicalName: this.form.cardPhysicalName,
          cardTypeSortName: this.form.cardTypeSortName,
          cardTypeName: this.form.cardTypeName,
          cardOrientation: this.form.cardOrientation,
          poolScene: this.form.poolScene,
          status: this.form.status,
          remark: this.form.remark,
          operation: "submit"
        };
        // 数量与状态保持一致：入库为正、出库为负
        const num = Number(payload.total);
        if (!isNaN(num) && num !== 0) {
          payload.total = payload.status === "2" ? -Math.abs(num) : Math.abs(num);
        }
        this.submitLoading = true;
        const request = payload.id ? cardInventoryUpdate : cardInventorySave;
        request(payload)
          .then(res => {
            this.submitLoading = false;
            if (res.data.code === 200) {
              this.$message.success(payload.id ? "修改成功" : "新增成功");
              this.open = false;
              this.getList();
            } else {
              this.$message.error(res.data.message || "操作失败");
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      });
    },
    /**
     * 保存可修改字段
     */
    saveForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        // 只提交实体字段，避免把列表里的派生字段（channelName、createTime 等）带上去
        const payload = {
          id: this.form.id,
          inventoryTime: this.form.inventoryTime,
          operationName: this.form.operationName,
          channelId: this.form.channelId,
          iccidStart: this.form.iccidStart,
          iccidEnd: this.form.iccidEnd,
          total: this.form.total,
          cardPhysicalName: this.form.cardPhysicalName,
          cardTypeSortName: this.form.cardTypeSortName,
          cardTypeName: this.form.cardTypeName,
          cardOrientation: this.form.cardOrientation,
          poolScene: this.form.poolScene,
          status: this.form.status,
          remark: this.form.remark,
          operation: "save"
        };
        // 数量与状态保持一致：入库为正、出库为负
        const num = Number(payload.total);
        if (!isNaN(num) && num !== 0) {
          payload.total = payload.status === "2" ? -Math.abs(num) : Math.abs(num);
        }
        this.submitLoading = true;
        const request = payload.id ? cardInventoryUpdate : cardInventorySave;
        request(payload)
          .then(res => {
            this.submitLoading = false;
            if (res.data.code === 200) {
              this.$message.success(payload.id ? "修改成功" : "新增成功");
              this.open = false;
              this.getList();
            } else {
              this.$message.error(res.data.message || "操作失败");
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      });
    },
    /** 取消 */
    cancel() {
      this.open = false;
    },
    /** 弹窗关闭后清空，避免下次打开残留校验态 */
    dialogClosed() {
      this.submitLoading = false;
      this.resetFormData();
    },

    /** 运营商标签配色 */
    operatorTagType(name) {
      const hit = this.operatorOptions.find(item => item.value === name);
      return hit ? hit.tag : "info";
    },
    /** 数量文案：入库为正、出库为负 */
    formatTotal(total) {
      if (total === undefined || total === null || total === "") return "--";
      const num = Number(total);
      if (isNaN(num)) return String(total);
      return num > 0 ? `+${num}` : `${num}`;
    },
    /** 数量配色：入库绿、出库橙 */
    totalClass(total) {
      const num = Number(total);
      if (isNaN(num) || num === 0) return "total-text";
      return num > 0 ? "total-text total-text--in" : "total-text total-text--out";
    },
    /** 出入库文案：优先取 status，缺省用数量正负判断 */
    statusText(row) {
      const hit = this.statusOptions.find(item => String(item.value) === String(row.status));
      if (hit) return hit.label;
      if (row.status) return row.status;
      const num = Number(row.total);
      if (!isNaN(num) && num !== 0) return num > 0 ? "入库" : "出库";
      return "--";
    },
    /** 出入库标签配色 */
    statusTagType(row) {
      const hit = this.statusOptions.find(item => String(item.value) === String(row.status));
      if (hit) return hit.tag;
      const num = Number(row.total);
      if (!isNaN(num) && num !== 0) return num > 0 ? "success" : "warning";
      return "info";
    },
    /** 是否出库行：数量正负为准，status 兜底 */
    isOutbound(row) {
      const num = Number(row.total);
      if (!isNaN(num) && num !== 0) return num < 0;
      return String(row.status) === "2";
    },
    /** 出库行扣减的来源入库单号列表（支持逗号/顿号分隔多个） */
    sourceOrderList(row) {
      if (!row.sourceOrderNum) return [];
      return String(row.sourceOrderNum)
        .split(/[,，、;；\s]+/)
        .filter(Boolean);
    },
    /** 打开扣减明细：查看某入库单被哪些出库单扣减 */
    openDeductDetail(orderNum) {
      if (!orderNum) return;
      // 来源入库单摘要：优先取当前列表里的行（含入库数量/剩余量），跨页时只展示单号
      this.deductSource = this.tableData.find(
        item => item.orderNum === orderNum && !this.isOutbound(item)
      ) || { orderNum };
      this.deductList = [];
      this.deductOpen = true;
      this.deductLoading = true;
      // 反查：按来源入库单号过滤出库记录（后端需支持 model.sourceOrderNum 过滤）
      cardInInventoryList({  sourceOrderNum: orderNum})
        .then(res => {
          this.deductLoading = false;
          if (res.data.code === 200) {
            this.deductList = res.data.data || [];
          } else {
            this.$message.error(res.data.message || "获取扣减明细失败");
          }
        })
        .catch(() => {
          this.deductLoading = false;
        });
    },
    /** 表格合计行（footer）：本页入库/出库/剩余，按列标题落到对应单元格 */
    getPageSummary({ columns }) {
      const { inTotal, outTotal, remain } = this.pageStat;
      const textMap = {
        "序号": "合计",
        "入库时间": `入库：+${this.formatNumber(inTotal)}`,
        "订单号": `出库：-${this.formatNumber(outTotal)}`,
        "运营商 / 卡源": `剩余：${this.formatNumber(remain)}`
      };
      return columns.map(column => textMap[column.label] || "");
    },
    /** 千分位 */
    formatNumber(val) {
      if (val === undefined || val === null || val === "") return "--";
      const num = Number(val);
      if (isNaN(num)) return String(val);
      return num.toLocaleString("zh-CN");
    },
    /** 复制 */
    copy(data) {
      const oInput = document.createElement("input");
      oInput.value = data;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message({ message: "复制成功", type: "success", duration: 1000 });
    }
  }
};
</script>

<style lang="less" scoped>
.card-inventory-page {
  // 汇总条
  .summary-block {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 12px;

    .summary-item {
      flex: 1;
      min-width: 160px;
      background: #fff;
      border: 1px solid #ebeef5;
      border-left-width: 3px;
      border-radius: 4px;
      padding: 12px 16px;

      .summary-label {
        font-size: 13px;
        color: #909399;
        line-height: 20px;
      }

      .summary-value {
        display: inline-block;
        font-size: 22px;
        font-weight: 600;
        line-height: 30px;
        color: #303133;
      }

      .summary-unit {
        display: inline-block;
        margin-left: 4px;
        font-size: 12px;
        color: #c0c4cc;
      }
    }

    .summary-item--in { border-left-color: #67c23a; }
    .summary-item--out { border-left-color: #e6a23c; }
    .summary-item--net { border-left-color: #409eff; }
    .summary-item--count { border-left-color: #909399; }
  }

  // 查询区
  .query-block {
    background: #fff;
    border-radius: 4px;
    padding-top: 8px;
    margin-bottom: 12px;

    .el-form-item {
      margin-bottom: 12px;
      margin-right: 12px;
    }
  }

  // 表格
  .data-table {
    width: 100%;
  }

  // 单元格：竖排两行，避免多列堆叠标签
  .cell-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1.5;

    .cell-text {
      font-size: 13px;
      color: #303133;
    }

    .cell-sub {
      font-size: 12px;
      color: #909399;
    }

    // 字段名前缀：区分同一列里的起止号段
    .cell-label {
      color: #909399;
      font-weight: normal;
    }
  }

  .cell-flex {
    display: flex;
    align-items: center;
    justify-content: center;

    .cell-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 4px;
    }

    .copy-icon {
      font-size: 14px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }

  .total-text {
    font-size: 13px;
    font-weight: 600;
    color: #606266;

    &--in {
      color: #67c23a;
    }

    &--out {
      color: #e6a23c;
    }
  }

  // 表格合计行（footer）：本页入库/出库/剩余
  // 列序：1 展开 / 2 序号 / 3 入库时间 / 4 订单号 / 5 运营商·卡源
  /deep/ .el-table__footer-wrapper {
    tbody td {
      background: #fafafa;
    }

    .cell {
      font-size: 13px;
      font-weight: 600;
      color: #606266;
    }

    tbody td:nth-child(2) .cell { color: #303133; }
    tbody td:nth-child(3) .cell { color: #67c23a; }
    tbody td:nth-child(4) .cell { color: #e6a23c; }
    tbody td:nth-child(5) .cell { color: #409eff; }
  }

  .empty-text {
    padding: 30px 0;
    color: #c0c4cc;
  }

  // 新增/修改弹窗：紧凑间距，两列栅格
  .inventory-form {
    /deep/ .el-form-item {
      margin-bottom: 14px;
      padding-right: 12px;
    }

    /deep/ .el-input-number {
      line-height: normal;

      .el-input__inner {
        text-align: left;
      }
    }
  }

  // 行内展开区：辅助属性折叠在当前行下面（对齐卡列表 table-expand 风格）
  .table-expand {
    margin: 4px 20px;
    font-size: 13px;

    /deep/ .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        color: #99a9bf;
        font-weight: normal;
      }
    }

    // 展开行内的 cell-flex 不要撑满内容区，与其他 span 值保持同宽紧密度
    .cell-flex {
      display: inline-flex;
    }
  }

  // 查询控件定宽，保证换行后仍对齐
  .wd-150 { width: 150px; }
  .wd-180 { width: 180px; }
  .wd-200 { width: 200px; }
  .wd-340 { width: 340px; }
}

// 扣减链路链接：列表与 append-to-body 弹窗均生效（scoped 按属性匹配，不依赖祖先链）
.order-link {
  color: #409eff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.source-link {
  display: inline-block;
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

// 弹窗底部操作提示：保存可改 / 提交锁定（append-to-body 脱离祖先链，样式放顶层）
.submit-tip {
  margin-bottom: 10px;
  padding: 7px 12px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  color: #409eff;
  text-align: left;

  i {
    margin-right: 4px;
  }
}

// 扣减明细弹窗
.deduct-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #606266;
}

.deduct-total-out {
  font-weight: 600;
  color: #e6a23c;
}

.deduct-empty {
  padding: 24px 0;
  color: #c0c4cc;
}
</style>
